import { IPaidPublicationState } from './types';

export const defaultState: IPaidPublicationState = {
  days: 0,
  autoProlong: false,
  highDemandCoefficient: 0,
  isEdit: 'edit',
  isPaid: false,
  moderation: {
    isAllowed: true,
    unavailableReasonType: null,
  },
  price: 0,
  token: '',
  initial: true,
};
